import { Alert, Link } from '@mm/components';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { ChannelSpecificDemarcator } from '../ChannelSpecificDemarcator/ChannelSpecificDemarcator';
import styles from './ChannelSpecificContainer.module.css';

type Props = {
  channel: 'web_chat' | 'facebook';
  children: React.ReactNode | React.ReactNode[];
  usedInSlideout?: boolean;
  onAlertTextClick?: () => void;
};
export const ChannelSpecificContainer = (props: Props) => {
  const { channel, children, usedInSlideout, onAlertTextClick } = props;

  const { id: botId, chatWidgetChannel } = useSelector(activeChatbotSelector);

  const disabled =
    chatWidgetChannel !== 'omnichat' && chatWidgetChannel !== channel;

  return (
    <div className={styles.container}>
      {!usedInSlideout && (
        <ChannelSpecificDemarcator
          webchat={channel === 'web_chat'}
          facebook={channel === 'facebook'}
          addMarginAbove
        />
      )}
      <div
        className={classNames({
          [styles.disabledChildContainer]: disabled,
        })}
      >
        {children}
      </div>
      {disabled && (
        <div className={styles.disabledBubbleContainer}>
          <Alert type="warning" showCloseIcon={false}>
            <div className={styles.disabledBubbleText}>
              Website Chat Widget is set to{' '}
              {chatWidgetChannel === 'facebook'
                ? 'Facebook Messenger'
                : 'Webchat'}{' '}
              only.
            </div>
            {onAlertTextClick && (
              <div onClick={onAlertTextClick} className={styles.alertAction}>
                Click here to enable{' '}
                {chatWidgetChannel === 'facebook'
                  ? 'Webchat'
                  : 'Facebook Messenger'}
              </div>
            )}
            {!onAlertTextClick && (
              <Link
                className={styles.disabledBubbleLink}
                to={BotBuilderRoutes.settingsCustomerChatWidget.getLink({
                  chatbotId: botId,
                })}
                capitalize={false}
              >
                Click here to enable{' '}
                {chatWidgetChannel === 'facebook'
                  ? 'Webchat'
                  : 'Facebook Messenger'}
              </Link>
            )}
          </Alert>
        </div>
      )}
    </div>
  );
};
